import React from 'react';
import { Modal, Backdrop, Fade, Grid, Typography, Button } from '@material-ui/core';
import RenderFieldBasedOnType from '../../CreateStepperView/RenderFieldsBasedOnType';
import useStyles from './style';

const SupplementalInfoModel = (props) => {
    const { open, handleCloseModel, formDataElements, handleOnFieldChange, dataObj, options, selectedStep, editingIndex, handleSave, formData } = props;
    const classes = useStyles();

    console.log('props**SupplementalInfoModel', props, editingIndex)

    return <Modal
        open={open}
        onClose={handleCloseModel}
        className={classes.modal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
    >
        <Fade in={open}>
            <div className={`${classes.modalPaper} myScrollContainer`}>
                <div className={classes.modalHeader}>
                    <Typography className={classes.modalHeaderTitle}> {editingIndex?.editMode ? 'Edit Data point' : editingIndex?.openMode ? 'Add Data point' : editingIndex?.viewMode ? 'View Data point' : ''}</Typography>
                </div>

                <div className={classes.modalForm}>
                    {formDataElements?.length > 0 &&
                        formDataElements.map((element, index) => (
                            <Grid item key={index} xs={element.xs ? element.xs : 12} className={classes.formItem}>
                                <Typography className={classes.formLabel}>{element.label}</Typography>
                                <RenderFieldBasedOnType
                                    {...props}
                                    classes={classes}
                                    element={{ ...element, readOnly: editingIndex?.viewMode }}
                                    onChange={handleOnFieldChange}
                                    dataObj={formData}
                                    options={element?.data?.options ? element.data.options : {}}
                                    selectedStep={props.selectedStep}
                                />
                                <Typography className={classes.formHelper}>{element.helperText}</Typography>
                            </Grid>
                        ))}
                </div>

                <div className={classes.modalFooter}>
                    <Button variant="contained" size="small" className={classes.modalBtn} onClick={handleCloseModel}>
                        Close
                    </Button>
                    {
                       (editingIndex?.editMode || editingIndex?.openMode) && (
                            <Button variant="contained" size="small" className={classes.modalBtnPrimary} onClick={handleSave}>
                                {editingIndex?.editMode ? 'Update' : (editingIndex?.openMode ? 'Add' : '')}
                            </Button>
                        )
                    }
                </div>
            </div>
        </Fade>
    </Modal>;
};

export default SupplementalInfoModel;